module.exports = __webpack_public_path__ + "img/lieferando-at.d007642a.png";